import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  table: {
    boxShadow: 'none'
  },
  cellContent: {
    borderRadius: '2px',
    display: 'flex',
    alignItems: 'center',
    padding: '5px 10px'
  },
  cellLeft: {
    width: '100%'
  },
  rightAlign: {
    textAlign: 'right'
  }
});
export default useStyles;